<template>
	<v-btn 
		:href="href"
		:title="title"
		v-bind="$attrs"
	>
		<slot>{{ config.mail }}</slot>
	</v-btn>
</template>

<script>

const nuxtConfig = require('~/nuxt.config').default
import { mapGetters } from 'vuex'

export default {
	data:() => ({
		href: null,
		title: null
	}),
	computed: {
		...mapGetters(['config'])
	},
	mounted() {
		let getParams = this.$attrs.params || ''
		let url = `${nuxtConfig.hostname}${this.$route.fullPath}`
		url = this.$attrs.url ? `${this.$attrs.url}${getParams}` : `${url}${getParams}`
		this.title = this.$attrs.title || `ส่งเมลล์ถึง ${this.config.company}`
		this.href = this.$attrs.mail ? `mailto:${this.$attrs.mail}?subject=${this.title}&body=${url}` : `mailto:${this.config.mail}?subject=${this.title}&body=${url}`
	}
}

</script>
